import { Colors, BorderRadiuses } from 'styles/enums';
import cssValue from 'shared/utils/cssUtility';
import { checkIsOnlineVisit } from 'shared/utils/checkIsOnlineVisit';

const getTokens = () => {
  const isOnlineVisit = checkIsOnlineVisit();
  if (isOnlineVisit) {
    return {
      colorPrimary: cssValue(Colors.ThemeExternalPrimary),
      colorPrimaryText: cssValue(Colors.ThemeTextPrimary),
      colorText: cssValue(Colors.ThemeTextPrimary),
      colorTextBase: cssValue(Colors.ThemeTextPrimary),
      colorLinkActive: cssValue(Colors.ThemeExternalDark),
      colorLinkHover: cssValue(Colors.ThemeExternalDark)
    };
  } else {
    return {
      colorPrimary: cssValue(Colors.ThemePrimary),
      colorPrimaryText: cssValue(Colors.ThemeTextPrimary),
      colorText: cssValue(Colors.ThemeTextPrimary),
      colorTextBase: cssValue(Colors.ThemeTextPrimary),
      colorLinkActive: cssValue(Colors.ThemeDark),
      colorLinkHover: cssValue(Colors.ThemeDark)
    };
  }
};

export const baseTheme = {
  token: getTokens(),
  components: {
    Button: {
      borderRadius: +cssValue(BorderRadiuses.ButtonsBorderRadius)
    },
    Input: {
      activeShadow: 'transparent'
    },
    Select: {},
    DatePicker: {
      activeShadow: 'transparent'
    },
    Checkbox: {}
  }
};

export const getAffiliateTheme = (affiliateVariables: {
  [key: string]: string;
}) => {
  const isOnlineVisit = checkIsOnlineVisit();
  const colorPrimary =
    (isOnlineVisit
      ? affiliateVariables[Colors.ThemeExternalPrimary]
      : affiliateVariables[Colors.ThemePrimary]) ||
    baseTheme.token.colorPrimary;
  const colorPrimaryText =
    affiliateVariables[Colors.ThemeTextPrimary] ||
    baseTheme.token.colorPrimaryText;
  const colorLinkActive =
    (isOnlineVisit
      ? affiliateVariables[Colors.ThemeExternalDark]
      : affiliateVariables[Colors.ThemeDark]) ||
    baseTheme.token.colorLinkActive;
  const colorLinkHover =
    (isOnlineVisit
      ? affiliateVariables[Colors.ThemeExternalDark]
      : affiliateVariables[Colors.ThemeDark]) || baseTheme.token.colorLinkHover;
  const buttonsBorderRadius =
    affiliateVariables[BorderRadiuses.ButtonsBorderRadius] ||
    baseTheme.components.Button.borderRadius;

  const inputsBorderColor =
    affiliateVariables[Colors.ThemeInputsBorderHover] ||
    (isOnlineVisit
      ? affiliateVariables[Colors.ThemeExternalPrimary]
      : affiliateVariables[Colors.ThemePrimary]) ||
    baseTheme.token.colorPrimary;

  const inputTextColor = affiliateVariables[Colors.ThemeInputsTextColor];

  return {
    token: {
      colorPrimary,
      colorPrimaryText,
      colorText: colorPrimaryText,
      colorTextBase: colorPrimaryText,
      colorLinkActive,
      colorLinkHover
    },
    components: {
      ...baseTheme.components,
      Button: {
        ...baseTheme.components.Button,
        borderRadius: +buttonsBorderRadius,
        colorPrimary: affiliateVariables[Colors.ThemeButtonPrimary],
        colorPrimaryHover:
          affiliateVariables[Colors.ThemeButtonPrimaryHover] ||
          affiliateVariables[Colors.ThemeButtonPrimary],
        colorPrimaryActive: affiliateVariables[Colors.ThemeButtonPrimary],
        colorBgContainerDisabled: affiliateVariables[Colors.ThemeButtonPrimary],
        colorTextDisabled: affiliateVariables[Colors.ThemeTextDisabled]
      },
      Input: {
        ...baseTheme.components.Input,
        colorPrimary: inputsBorderColor,
        hoverBorderColor: inputsBorderColor,
        colorPrimaryActive: inputsBorderColor,
        colorText: inputTextColor || colorPrimaryText
      },
      Checkbox: {
        colorPrimary: affiliateVariables[Colors.ThemeSecondary],
        colorPrimaryHover: affiliateVariables[Colors.ThemeSecondary],
        colorPrimaryActive: affiliateVariables[Colors.ThemePrimary],
        colorBorder: affiliateVariables[Colors.ThemeSecondary],
        colorText: affiliateVariables[Colors.ThemeTextPrimary],
        colorTextChecked: affiliateVariables[Colors.ThemeTextLight]
      },
      Select: {
        ...baseTheme.components.Select,
        colorPrimary: inputsBorderColor,
        colorPrimaryHover: inputsBorderColor,
        optionSelectedBg: affiliateVariables[Colors.ThemePrimary],
        optionSelectedColor: affiliateVariables[Colors.ThemeTextLight]
      },
      DatePicker: {
        ...baseTheme.components.DatePicker,
        colorPrimary: inputsBorderColor,
        hoverBorderColor: inputsBorderColor
      },
      Radio: {
        colorPrimary: affiliateVariables[Colors.ThemeSecondary]
      },
      Spin: {
        colorPrimary: affiliateVariables[Colors.ThemePrimary],
        colorText: affiliateVariables[Colors.ThemeTextPrimary]
      },
      Avatar: {
        colorPrimary: affiliateVariables[Colors.ThemeButtonPrimary],
        colorTextPlaceholder: affiliateVariables[Colors.ThemeTextLight],
        colorBgContainer: affiliateVariables[Colors.ThemeButtonPrimary],
        colorText: affiliateVariables[Colors.ThemeTextLight]
      },
      Modal: {
        colorText: inputTextColor || affiliateVariables[Colors.ThemeTextPrimary]
      }
    }
  };
};
